// Preferred first; Safari only supports mp4. Both are accepted by the transcription API.
// Verified on iOS Safari and iOS Chrome (both WebKit, so audio/mp4); desktop Chrome/Firefox
// (audio/webm) still rely on the same server-side handling and haven't been manually verified.
const RECORDING_MIME_TYPES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/mp4",
];

export const pickRecordingMimeType = () =>
  typeof MediaRecorder === "undefined"
    ? undefined
    : RECORDING_MIME_TYPES.find((type) => MediaRecorder.isTypeSupported(type));

// The transcription API sniffs the container from the filename extension.
export const getRecordingFileExtension = (mimeType: string) =>
  mimeType.includes("mp4") ? "mp4" : "webm";
